import { render, staticRenderFns } from "./safetyProductionList.vue?vue&type=template&id=0a8076f6&scoped=true&"
import script from "./safetyProductionList.vue?vue&type=script&lang=js&"
export * from "./safetyProductionList.vue?vue&type=script&lang=js&"
import style0 from "./safetyProductionList.vue?vue&type=style&index=0&id=0a8076f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8076f6",
  null
  
)

export default component.exports